import React from 'react';
import { EXAM_TYPE } from '../../../routes/ExamRoute';
import NonNationalAeisTypeExam from './AEIS';
import NonNationalSpersTypeExam from './SPERS';

const NonNationalExam = ({
  examType,
  examTitle,
  path,
}: {
  examType: string;
  examTitle: string;
  path: string;
}) => {
  if (examType === EXAM_TYPE.AEIS || examType === EXAM_TYPE.SAEIS) {
    return <NonNationalAeisTypeExam examType={examType} examTitle={examTitle} path={path} />;
  }
  if (examType === EXAM_TYPE.SPERS || examType === EXAM_TYPE.SPERSSec) {
    return <NonNationalSpersTypeExam examType={examType} examTitle={examTitle} path={path} />;
  }
  return null;
};

export default NonNationalExam;
